import React, { forwardRef } from 'react'
import { Box, ThemeUIStyleObject } from 'theme-ui'
import { Card, SecondaryCardProps } from '.'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'

export default forwardRef<HTMLDivElement, SecondaryCardProps>(function CardSecondary(
  {
    children,
    topColor = 'black',
    backgroundColor = 'black',
    sx = {},
    header = null,
    footer = null,
    hasBoxShadow = true,
    isCardView = false,
    ...props
  }: SecondaryCardProps,
  ref,
): React.ReactElement {
  const bgc: ThemeUIStyleObject = { backgroundColor }
  const isMobile = useBreakpointIndex() === 0
  const perspectiveSize = isCardView || isMobile ? '15px' : '22px'

  return (
    <>
      <Box
        variant="cards.top"
        sx={{
          flexShrink: 0,
          transformStyle: 'preserve-3d',
          transform: `perspective(${perspectiveSize}) rotateX(3deg) translateZ(-0.2px)`,
          backgroundColor: topColor,
          maxHeight: '0.7rem',
        }}
      />
      <Card
        sx={{
          height: 'auto',
          flexShrink: 0,
          boxShadow: hasBoxShadow ? 'rgb(0 0 0 / 30%) 0px 15px 20px 0px' : 'none',
          ...bgc,
          ...sx,
        }}
        header={header}
        footer={footer}
        ref={ref}
        {...props}
      >
        {children}
      </Card>
    </>
  )
})
